import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=4427543c&scoped=true"
import script from "./tips.vue?vue&type=script&lang=js"
export * from "./tips.vue?vue&type=script&lang=js"
import style0 from "./tips.vue?vue&type=style&index=0&id=4427543c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427543c",
  null
  
)

export default component.exports